import {Injectable} from '@angular/core';
import {AbstractSecurityStorage} from 'angular-auth-oidc-client';
import {CookieStorage} from '@app/core/security/cookie-storage';
import {BrowserStorage} from '@app/core/security/browser-storage';
import {environment} from '@env/environment';
import {AuthenticationService} from '@app/core/service/authentication.service';
import {CookieService} from 'ngx-cookie-service';

export type StorageKeys =
    | 'authnResult'
    | 'authzData'
    | 'access_token_expires_at'
    | 'authWellKnownEndPoints'
    | 'userData'
    | 'authNonce'
    | 'codeVerifier'
    | 'authStateControl'
    | 'reusable_refresh_token'
    | 'session_state'
    | 'storageSilentRenewRunning'
    | 'storageCodeFlowInProgress'
    | 'storageCustomParamsAuthRequest'
    | 'storageCustomParamsRefresh'
    | 'storageCustomParamsEndSession'
    | 'redirect'
    | 'configIds'
    | 'jwtKeys'
    | 'popupauth';

const CookieKeys: StorageKeys[] = ['authnResult', 'authzData', 'access_token_expires_at'];
export const COOKIE_SCHOOL_PASSPORT_LOGIN_DOMAIN_KEY_NAME = `${environment.spOidcClientId}_schoolPassportLoginDomain`;

@Injectable()
export class SessionCookieStorage implements AbstractSecurityStorage {

    constructor(private browserStorage: BrowserStorage = new BrowserStorage(),
                private cookieStorage: CookieStorage = new CookieStorage(new CookieService(document, 'browser'))) {
    }

    public read(key: string): any {
        const browserStorageList = AuthenticationService.getBrowserStorageList(key, this.browserStorage);
        let cookiesStorageList = AuthenticationService.getCookiesStorageList(key, this.cookieStorage);
        cookiesStorageList = AuthenticationService.decodeAndParseObjectValues(cookiesStorageList);

        const combinedStorage = Object.assign({}, browserStorageList, cookiesStorageList);
        return combinedStorage ? JSON.stringify(combinedStorage) : '';
    }

    public write(key: string, value: any): void {
        if (this.isCookieKey(key)) {
            this.cookieStorage.write(key, value);
        } else {
            this.browserStorage.write(key, value);
        }
    }

    public remove(key: string): void {
        if (this.isCookieKey(key)) {
            this.cookieStorage.remove(key);
        } else {
            this.browserStorage.remove(key);
        }
    }

    public clear(key?: string, path?: string, domain?: string, secure?: boolean, sameSite?: 'Lax' | 'None' | 'Strict'): void {
        if (this.isCookieKey(key)) {
            return this.cookieStorage.clear(path, domain, secure, sameSite);
        } else {
            return this.browserStorage.clear();
        }
    }

    private isCookieKey(key: string) {
        return CookieKeys.indexOf(<StorageKeys>key.substr((environment.spOidcClientId + '_').length)) > -1;
    }
}
